import {LocalStorage} from '@chekin/core';
import {useReservation} from 'context/reservation';
import {PATHS} from 'routes/constants';
import {usePropertyProtection} from '../usePropertyProtection';

const getShownKey = (reservationId: string) =>
  `guestapp:depositSetupShown:${reservationId}`;

function markDepositSetupShown(reservationId?: string) {
  if (reservationId) LocalStorage.set(getShownKey(reservationId), true);
}

function useDepositSetupGate() {
  const {data: reservation} = useReservation();
  const {
    insuranceSetup,
    isFirstLoading,
    isInsuranceSetupInit,
    isMultipleDeposits,
    isSecurityDeposit,
    isSecurityDepositOptional,
    isWaivoProtection,
    isWaivoProtectionOptional,
  } = usePropertyProtection();

  const hasProtectionChoice =
    isMultipleDeposits ||
    (isSecurityDeposit && isSecurityDepositOptional) ||
    (isWaivoProtection && isWaivoProtectionOptional);

  const wasShown = Boolean(
    reservation?.id && LocalStorage.get<boolean>(getShownKey(reservation.id)),
  );

  const needsDepositSetup =
    !insuranceSetup &&
    !reservation?.security_deposit_marked_as_paid &&
    !wasShown &&
    Boolean(isInsuranceSetupInit) &&
    hasProtectionChoice;

  return {
    isChecking: isFirstLoading || !isInsuranceSetupInit,
    needsDepositSetup,
  };
}

function usePaymentsEntryPath() {
  const {needsDepositSetup} = useDepositSetupGate();
  return needsDepositSetup ? PATHS.deposits : PATHS.payments.main;
}

export {markDepositSetupShown, useDepositSetupGate, usePaymentsEntryPath};
